module.exports = __webpack_public_path__ + "static/img/plate_rich.b31d3a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls37-1/plate_rich.png
// module id = X90M
// module chunks = 12